import { jsx, jsxs } from 'react/jsx-runtime';
import 'classnames';
import '../../server-components/Table/components/HeaderCell.module.scss.js';
import Flex from '../../server-components/layout/Flex/Flex.js';
import '../../server-components/layout/Row/Row.module.scss.js';
import '../../server-components/layout/Stack/Stack.js';
import Box from '../../server-components/layout/Box/Box.js';
import '../../server-components/icons/ActivityIcon.js';
import '../../server-components/icons/ArrowDownIcon.js';
import '../../server-components/icons/ArrowDownRightCircleIcon.js';
import '../../server-components/icons/ArrowLeftAlignIcon.js';
import '../../server-components/icons/ArrowLeftIcon.js';
import '../../server-components/icons/ArrowRightAlignIcon.js';
import '../../server-components/icons/ArrowRightIcon.js';
import '../../server-components/icons/ArrowUpIcon.js';
import '../../server-components/icons/ArrowUpRightCircleIcon.js';
import '../../server-components/icons/ArrowsAngleExpandIcon.js';
import '../../server-components/icons/BankIcon.js';
import BlankNotepadIcon from '../../server-components/icons/BlankNotepadIcon.js';
import '../../server-components/icons/CheckIcon.js';
import '../../server-components/icons/ChevronDownIcon.js';
import '../../server-components/icons/ChevronRightIcon.js';
import '../../server-components/icons/ChevronUpIcon.js';
import '../../server-components/icons/CopyIcon.js';
import '../../server-components/icons/CrossIcon.js';
import '../../server-components/icons/DaiIcon.js';
import '../../server-components/icons/DangerIcon.js';
import '../../server-components/icons/DownSortIcon.js';
import '../../server-components/icons/ExclamationTriangleIcon.js';
import '../../server-components/icons/ExpandKpiIcon.js';
import '../../server-components/icons/EyeIcon.js';
import '../../server-components/icons/EyeSlashIcon.js';
import '../../server-components/icons/Grid1x2Icon.js';
import '../../server-components/icons/InfoCircleIcon.js';
import '../../server-components/icons/ListIcon.js';
import '../../server-components/icons/LockIcon.js';
import '../../server-components/icons/MediumIcon.js';
import '../../server-components/icons/MoonIcon.js';
import '../../server-components/icons/PiggyBankIcon.js';
import '../../server-components/icons/QuestionMarkCircleIcon.js';
import '../../server-components/icons/ShieldIcon.js';
import '../../server-components/icons/SunIcon.js';
import '../../server-components/icons/UpSortIcon.js';
import '../../server-components/icons/XIcon.js';
import '../../server-components/Table/Table.module.scss.js';
import 'react';
import '../../server-components/Table/components/TableRow.module.scss.js';
import '../../server-components/Table/components/Pagination.module.scss.js';
import '../../server-components/Text/Text.js';
import '../../server-components/Table/components/TableCell/TableCell.module.scss.js';
import '../../server-components/Card/Card.module.scss.js';
import '../../server-components/List/List.module.scss.js';
import '../../server-components/ErrorBox/ErrorBox.module.scss.js';
import '../../server-components/InfoBox/InfoBox.module.scss.js';
import '../../server-components/KpiCard/KpiCard.module.scss.js';
import '../../server-components/TrendValue/TrendValue.module.scss.js';
import '../../server-components/Modal/Modal.module.scss.js';
import '../ThemeProvider.js';
import '../Tabs/Tabs.module.scss.js';
import '../ThemeModeSelector/ThemeModeSelector.module.scss.js';
import '../ExpandableCard/ExpandableCard.module.scss.js';
import '../ExpandableKpiCard/ExpandableKpiCard.module.scss.js';
import '../CopyButton/CopyButton.module.scss.js';
import 'ethereum-blockies-base64';
import 'luxon';
import '../WalletAddress/WalletAddress.module.scss.js';
import '../filters/TextSearchFilter/TextSearchFilter.module.scss.js';
import '@blockanalitica/ui';
import '../sidebars/FixedSidebar/components/MobileTopNavBar/MobileTopNavbar.module.scss.js';
import '../sidebars/FixedSidebar/components/Sidebar/Sidebar.module.scss.js';
import '../sidebars/FixedSidebar/FixedSidebar.module.scss.js';
import '../sidebars/CollapsableSidebar/CollapsableSidebar.module.scss.js';
import '../FormattedCurrency/FormattedCurrency.js';
import '../FormattedPercentage/FormattedPercentage.js';
import '../CurrencyValue/CurrencyValue.module.scss.js';
import '../PercentageValue/PercentageValue.module.scss.js';
import '../DisplaySwitch/DisplaySwitch.module.scss.js';
import '../Tooltip/Tooltip.js';
import 'lodash';
import '../charts/ChartJS.js';
import '../charts/components/ChartKpis/ChartKpis.module.scss.js';
import '../charts/components/ChartSingleValueIndicator/ChartSingleValueIndicator.module.scss.js';
import '../charts/BarChart/BarChart.module.scss.js';
import '../charts/LineChart/LineChart.module.scss.js';
import '../charts/AreaChart/AreaChart.module.scss.js';
import 'randomcolor';
import 'd3';
import '../Checkbox/Checkbox.module.scss.js';
import '../../server-components/Badge/Badge.module.scss.js';
import '../../server-components/HeatmapActivity/HeatmapActivity.module.scss.js';
import '../../server-components/Switch/Switch.module.scss.js';
import '../../server-components/Select/Select.module.scss.js';
import '../../server-components/pictograms/EthPictogram.js';
import '../../server-components/pictograms/EtherScanPictogram.js';
import '../../server-components/pictograms/DebankPictogram.js';
import '../../server-components/pictograms/ZapperPictogram.js';
import '../../server-components/pictograms/DaiPictogram.js';
import 'react-loading-skeleton';

function EmptyBox({ message = 'NO DATA', icon = null, ...rest }) {
    if (!icon) {
        icon = jsx(BlankNotepadIcon, {});
    }
    return (jsxs(Flex, { direction: "column", color: "color-muted", height: "8rem", alignItems: "center", justifyContent: "center", ...rest, children: [icon ? icon : null, jsx(Box, { as: "p", fontSize: "size--2", paddingTop: "space-2xs", children: message })] }));
}

export { EmptyBox as default };
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
